import {Controller} from "@hotwired/stimulus"

// Navbar fullscreen toggle: html.fullscreen (shell hidden via CSS, see application.scss)
// tracks ?fullscreen=1/true (kiosk bookmarks) or active browser fullscreen (Esc exits).
export class FullscreenController extends Controller {
	connect() {
		if (!document.fullscreenEnabled) this.element.hidden = true
		document.addEventListener("fullscreenchange", this.sync)
		this.sync()
	}

	disconnect() {
		document.removeEventListener("fullscreenchange", this.sync)
		document.documentElement.classList.remove("fullscreen")
	}

	expand() {
		document.documentElement.requestFullscreen()
	}

	sync = () => {
		const param = new URLSearchParams(window.location.search).get("fullscreen")
		const active = ["1", "true"].includes(param) || !!document.fullscreenElement
		document.documentElement.classList.toggle("fullscreen", active)
	}
}
